import { EffectsModule } from '@ngrx/effects';
// NgRx
import { StoreModule } from '@ngrx/store';

import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { RouterModule } from '@angular/router';

import {
  AnonymousGuard,
  ModuleAccessGuard,
  MwAuthGuard,
  MwCompanyGuard,
  MwUserAccessService,
  MwUserApiService,
  MwUserService,
  PreferenceResolve,
  UserActionGuard,
} from '../auth/services';
import {
  CompanyEffects,
  MwUserEffectsService,
  OIDCEffects,
  UserEffects,
  userReducers,
} from './@store';
import {
  companyFeatureKey,
  companyReducer,
} from './@store/company/company.reducer';
// Module stuff
import { MwCompanyApiService } from './services/company-api.service';
import { MwCompanyService } from './services/company.service';
import { MwPreferenceLoadedGuard } from './services/guards/preference-loaded.guard';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    StoreModule.forFeature(
      userReducers.userFeatureKey,
      userReducers.userReducer
    ),
    StoreModule.forFeature(companyFeatureKey, companyReducer),
    EffectsModule.forFeature([UserEffects, OIDCEffects, CompanyEffects]),
  ],
  providers: [
    MwAuthGuard,
    MwCompanyGuard,
    UserActionGuard,
    ModuleAccessGuard,
    AnonymousGuard,
    MwPreferenceLoadedGuard,
    MwUserApiService,
    MwUserEffectsService,
    MwUserService,
    MwUserAccessService,
    MwCompanyApiService,
    MwCompanyService,
    PreferenceResolve,
    {
      provide: 'AuthGuard',
      useClass: MwAuthGuard,
    },
  ],
  exports: [],
})
export class MwAuthModule {
  constructor(@Optional() @SkipSelf() parentModule: MwAuthModule) {
    if (parentModule) {
      throw new Error(
        'MwAuthModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
